var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2,
    transform: "translate(8,8)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9v11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.53afb284249e27f690ecc44fd262d2c6.svg";
export { ForwardRef as ReactComponent };